import { render, staticRenderFns } from "./FollowButton.vue?vue&type=template&id=f8e2b24c&scoped=true&"
import script from "./FollowButton.vue?vue&type=script&lang=js&"
export * from "./FollowButton.vue?vue&type=script&lang=js&"
import style0 from "./FollowButton.vue?vue&type=style&index=0&id=f8e2b24c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e2b24c",
  null
  
)

export default component.exports